/**
 * Toast — minimal transient notification.
 *
 * Used by T7 (Merge All confirmation) and reusable elsewhere. Renders into
 * a single shared container appended to <body> on first call. Each toast
 * auto-dismisses after `duration` ms (default 3500).
 */

const CONTAINER_ID = "ecf-toast-container";

function ensureContainer(): HTMLElement {
  let host = document.getElementById(CONTAINER_ID);
  if (!host) {
    host = document.createElement("div");
    host.id = CONTAINER_ID;
    host.className = "toast-container";
    host.setAttribute("role", "status");
    host.setAttribute("aria-live", "polite");
    document.body.appendChild(host);
  }
  return host;
}

export type ToastVariant = "success" | "error" | "info";

export function showToast(
  message: string,
  variant: ToastVariant = "info",
  duration = 3500,
): void {
  const host = ensureContainer();
  const toast = document.createElement("div");
  toast.className = `toast toast-${variant}`;
  toast.textContent = message;
  host.appendChild(toast);
  // trigger CSS transition
  requestAnimationFrame(() => toast.classList.add("toast-visible"));
  window.setTimeout(() => {
    toast.classList.remove("toast-visible");
    window.setTimeout(() => toast.remove(), 200);
  }, duration);
}
